export * from './educations.model';
export * from './educations.module';
export * from './educations.seed';
export * from './educations.types';
